export default __webpack_public_path__ + "static/media/gpay.5c81ce65.png";